enum FontClass {
  ArtName = "artNameFont",
  Body1 = "body1Font",
  Body1Medium = "body1MediumFont",
  Body1SemiBold = "body1SemiBoldFont",
  Body1Bold = "body1BoldFont",
  Body2 = "body2Font",
  Body2Medium = "body2MediumFont",
  Body2SemiBold = "body2SemiBoldFont",
  Body2Bold = "body2BoldFont",
  Body3 = "body3Font",
  Body3Medium = "body3MediumFont",
  Body3SemiBold = "body3SemiBoldFont",
  Body3Bold = "body3BoldFont",
  Header1 = "header1Font",
  Header2 = "header2Font",
  Header3 = "header3Font",
  NavLink = "navLinkFont",
  Price = "priceFont",
  Subheader = "subheaderFont",
  TinyLabel = "tinyLabelFont",
}

export default FontClass;
